import Vue from 'vue'
import Component from 'vue-class-component'

import * as appbaseTypes from '@appbase/store/types'
import { mapGetters, mapMutations } from 'vuex'
import { Prop, Watch } from 'vue-property-decorator'
import api from '@home/api'
import * as popupHelper from '@appbase/util'
import * as types from '@home/store/types'
import { ModalLayout } from '@appbase/templates'
import NoticeView from '@home/views/NoticePopup/NoticePreviewView.vue'
import localStorageHelper from '@appbase/util/local-storage-helper'


const EumCookiePrefix = ".EumDoNotPopup_"


@Component({
    components: {
        ModalLayout,
        NoticeView
    },
    computed: {
        ...mapGetters({
            isTeams: appbaseTypes.TEAMS,
            modalPopupItem : types.NOTICEPOPUP_MODAL_GET,
            modalPopupList : types.NOTICEPOPUP_MODAL_LIST_GET,
        }),
        
    },
    methods:{
        ...mapMutations({
            setTeams : appbaseTypes.TEAMS,
            setPopupItems: types.NOTICEPOPUP_SET,
            setModalPopupItem: types.NOTICEPOPUP_MODAL_SET,
            setModalPopupList: types.NOTICEPOPUP_MODAL_LIST_SET,
        })
    }
})
export default class PopupNotice extends Vue {
    @Prop({ type: String }) comCode!: string

    setPopupItems! : (data:Array<noticepopup.NoticeItem>) => void
    setModalPopupItem!: (data: noticepopup.ModalNoticeItem) => void
    setModalPopupList!: (data: noticepopup.ModalNoticeList) => void
    setTeams! : (value:boolean) => void

    isTeams!: boolean
    popupItems: Array<noticepopup.NoticeItem> = []
    modalPopupItem! : noticepopup.ModalNoticeItem
    modalPopupList! : noticepopup.ModalNoticeList

    created() {
        //테스트 위해서 teams모드 변경
/*        this.setTeams(true)*/
        //alert(`팝업알림 사용 : 팀즈사용 ${this.isTeams}`)
        this.initPopupNoticeData();
    }

    initPopupNoticeData() {
        api.home.getTodayNoticePopupList(this.comCode).then((res) => {
            // if(res.length >0) this.popupItems = res
            if (res.length > 0) {
                //Ticker 에서 사용 할 수 있도록 전체 데이터 store set
                //일반 브라우저 인경우는 팝업까지 함께 표시
                this.setPopupItems(res)

                if (this.isTeams == false) {
                    //일반 브라우저 브라우저
                    res.forEach(pop => {
                        this.popupNotice(pop)
                    })
                } 
                // 팀즈인 경우
                else{

                    // 쿠키가 존재하는 팝업 리스트 필터링
                    var cookieList = res.filter(x => this.isCookieKeyExists(`pop_n${x.noticePopupId}`));

                    // 쿠키가 없는 팝업 리스트 필터링 (필요한 경우)
                    var noCookieList = res.filter(x => !this.isCookieKeyExists(`pop_n${x.noticePopupId}`));

                    // 쿠키가 없는 경우 팝업 표시
                    if (!cookieList || cookieList.length === 0) {
                        if (res.length === 1) {
                            // 팝업이 하나일 때 바로 표시
                            this.setModalPopupItem({...res[0], isShow: true});
                        } else {
                            // 팝업이 여러 개일 때 리스트로 표시
                            var modalList = [...res]; // res 전체를 modalList로 복사
                            this.setModalPopupList({modalShow: true, curIdx: 0, items: modalList});
                        }
                    } else {
                        // 쿠키에 존재하는 팝업과 전체 팝업 리스트가 다를 때
                        var modalList:noticepopup.NoticeItem[] = []

                        // cookieList에 없는 팝업만 modalList에 추가
                        res.forEach(pop => {
                            if (!cookieList.some(cookie => cookie.noticePopupId === pop.noticePopupId)) {
                                modalList.push(pop);
                            }
                        });

                        // modalList가 존재하면 팝업 표시, 없으면 숨김 처리
                        if (modalList.length > 0) {
                            this.setModalPopupList({modalShow: true, curIdx: 0, items: modalList});
                        } else {
                            this.setModalPopupList({modalShow: false, curIdx: 0, items: []});
                        }
                    }
                 
                }
            }
        })
    }

    isCookieKeyExists(key: string) {
        var expires = localStorage.getItem(key)
        if(expires){
            var res = new Date(expires)>new Date()
            if(!res){
                localStorage.removeItem(key)
            }
            return res
        }
        return false
    }


    popupNotice(popup: noticepopup.NoticeItem) {
        //일반 브라우저인경우 개별 팝업처리 

        /**
        * 쿠키 확인해서 오늘 열지 않음 대상인지 확인한다
        * 관리자 페이지에서는 대상아님
        */

        const strCookie = document.cookie
        const findStr = `${EumCookiePrefix}_${popup.noticePopupId}`
        if (strCookie.indexOf(findStr) > -1) return

        if(popup.noticePopupType==1){
            popupHelper.openPopup(`noticePopup_${popup.noticePopupId}`, "/home/popup/notice",
            {
                htmlContent:true,
                popupId:popup.noticePopupId
            },
            {
                width: popup.width,
                height: popup.height,
            })
            var popupStr = JSON.stringify(popup)
            localStorageHelper.set(`$home/${popup.noticePopupId}/htmlcontent`, popupStr);
    
        }
        else{
            popupHelper.openPopup(`noticePopup_${popup.noticePopupId}`, "/home/popup/notice",
            {
                popupItem: popup
            },
            {
                width: popup.width,
                height: popup.height,
            })
        }

    }

    isShowModal(){
        if((this.modalPopupItem || this.modalPopupList.items) && this.isTeams == true){
            if(this.modalPopupItem.isShow == true || this.modalPopupList.modalShow) return true
        }

        return false
    }

    @Watch("modalPopupItem")
    onChangedModalPopupItem(){

    }

    close(){
        this.setModalPopupItem({
            ...this.modalPopupItem,
            isShow : false
        })
        this.setModalPopupList({
            items:this.modalPopupList.items,
            curIdx:0,
            modalShow:false
        })
    }

    setModalSize(){
        // width:600px;height:500px
        if(this.modalPopupItem && this.modalPopupItem.title && this.isTeams == true){
            return `width:${this.modalPopupItem.width}px;height:${this.modalPopupItem.height}px`
        }
        else if(this.modalPopupList.items && this.isTeams == true){
            let idx = this.modalPopupList.curIdx
            return `width:${this.modalPopupList.items[idx].width}px;height:${this.modalPopupList.items[idx].height}px`
        }
        return ""
    }

    setModalTitle(){
        if(this.modalPopupItem&& this.modalPopupItem.title && this.isTeams == true){
            return this.modalPopupItem.subject
        }
        else if(this.modalPopupList.items && this.isTeams == true){
            let idx = this.modalPopupList.curIdx
            return this.modalPopupList.items[idx].subject
        }

        // return ""
    }


}
 
